import styled from 'styled-components';

import palette from '@utils/theme/palette';

export const Container = styled.div`
  & .rc-tooltip-placement-bottomRight {
    margin-top: 100px;
  }
`;
export const TooltipTitle = styled.div`
  font-weight: 300;
  font-size: 12px;
  display: flex;
  max-width: 82px;
  width: 100%;
  justify-content: space-between;
  align-items: center;
`;

export const TooltipContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 4px;
`;
export const Wrapper = styled.div`
  height: 30px;
  display: block;
  justify-content: space-between;
  padding-top: 20px;
`;
export const SpanWrapper = styled.div<{ colorRating?: boolean }>`
  border-radius: 8px;
  max-width: 43px;
  width: auto;
  height: 30px;
  padding: 0px 5px 0px;
  background-color: ${({ colorRating }) =>
    colorRating ? palette.darkGreenScore : palette.orange};
`;
export const ContainerBox = styled.div`
  border-radius: 2px;
  background-color: ${({ theme }) => theme.palette.white};
  cursor: context-menu;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    z-index: 10;
  }
`;

export const ContainerHead = styled.div`
  display: flex;
`;
export const DivSpan = styled.div`
  display: flex;
  justify-content: center;
`;
export const ScoringLine = styled.div`
  display: flex;
  margin: 4px;
  min-height: 5px;
  border-radius: 4px;
  flex-direction: row-reverse;
  max-width: 40px;
  width: 100%;
`;
export const WrapperTitle = styled.div`
  width: 100px;
  display: grid;
  justify-items: end;
  line-height: 12px;
  margin-right: 6px;
  cursor: context-menu;
`;
export const Span = styled.span`
  color: white;
  margin: 3px;
`;
export const Note = styled.span`
  font-size: 12px;
  margin-left: 5px;
  font-weight: 300;
`;

export const Percent = styled.span`
  font-size: 12px;
`;
export const PercentWrapper = styled.div`
  max-width: 20px;
  width: 100%;
  display: flex;
  justify-content: flex-end;
`;
export const TotalPercent = styled.span`
  font-size: 12px;
  font-weight: 600;
`;
export const MainTitle = styled.span`
  font-size: 12px;
  font-weight: 600;
`;
export const Separate = styled.hr`
  display: block;
  border: 0;
  border-top: 1px solid ${({ theme }) => theme.palette.gray87};
  padding: 0;
`;
export const NoteWrapper = styled.div`
  display: flex;
  padding-left: 4px;
  align-items: center;
`;
export const TextWrapper = styled.div`
  display: flex;
  padding: 4px 2px 4px 6px;
  justify-content: space-between;
`;
export const TripAdvisorButton = styled.button`
  margin-top: 5px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  background-color: ${({ theme }) => theme.palette.NL20};
`;
export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: end;
`;
